import React, { useState, useRef, useEffect, memo, use } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Search, ChevronDown, Menu as MenuIcon, ShoppingBasket, FileText, Shield, Scale, Mail, Info, BookOpen, LogOut, User } from 'lucide-react';
import { CATEGORIES } from '../constants';
import MainLogo from '../Logo/MainLogo';

const Header = ({ onSearch, onSelectCategory }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const currentView = location.pathname;
    const [catOpen, setCatOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [user, setUser] = useState(null);
    console.log("user", user);
    const [profileMenuOpen, setProfileMenuOpen] = useState(false);
    const dropdownRef = useRef(null);
    // const menuRef = useRef(null);
    const profileMenuRef = useRef(null);

    const desktopMenuRef = useRef(null);
    const mobileMenuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setCatOpen(false);
            }

            if (
                desktopMenuRef.current &&
                !desktopMenuRef.current.contains(event.target) &&
                mobileMenuRef.current &&
                !mobileMenuRef.current.contains(event.target)
            ) {
                setMenuOpen(false);
            }

            if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
                setProfileMenuOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                // Attempt to decode JWT token to get user info
                const payload = JSON.parse(atob(token.split('.')[1]));
                console.log("payload", payload);
                setUser({
                    name: payload.sub,
                    username: payload.username || payload.email
                });
            } catch (e) {
                setUser(null);
            }
        } else {
            setUser(null);
        }
    }, [location]);

    const handleLogout = async () => {
        try {
            const token = localStorage.getItem('token');
            if (token) {
                // Call logout endpoint (optional, mainly for server-side logging)
                await fetch('https://comment-backend-beta.vercel.app/logout', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }).catch(() => {
                    // Ignore errors, logout is primarily client-side
                });
            }
        } catch (error) {
            console.error('Logout error:', error);
        } finally {
            // Remove token and reset user state
            localStorage.removeItem('token');
            setUser(null);
            setProfileMenuOpen(false);
            navigate('/');
        }
    };

    const handleProfileClick = () => {
        setProfileMenuOpen(false);
        navigate('/profile');
    };

    const handleHomeClick = () => {
        setProfileMenuOpen(false);
        navigate('/');
    };

    return (
        <header className="w-full bg-white border-b border-slate-100 px-4 md:px-6 h-14 flex items-center justify-between sticky top-0 z-[60]">
            <div className="flex items-center gap-2 cursor-pointer group">
                <div onClick={handleHomeClick} className="flex items-center justify-center text-[#4048c5]">
                    <MainLogo height={80} width={130} />
                </div>

            </div>

            <div className="hidden lg:flex flex-1 max-w-lg mx-8">
                <div className="relative w-full min-w-[300px]">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Search className="h-4 w-4 text-slate-400" />
                    </div>
                    <input
                        type="text"
                        className="block w-full pl-10 pr-3 py-1.5 bg-slate-50 border border-slate-200 rounded-lg text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:bg-white transition-all"
                        placeholder="Search Tools"
                        onChange={(e) => onSearch(e.target.value)}
                    />
                </div>
            </div>

            <div className="flex items-center gap-1 md:gap-5">
                <nav className="hidden xl:flex items-center gap-5 text-[13px] font-medium text-slate-600">
                    {/* <Link
                        to="/blog"
                        className={`transition-colors  ${currentView === '/blog' ? 'text-[#4048c5]' : 'hover:text-[#4048c5]'}`}
                    >
                        Blog
                    </Link> */}

                    <div className="relative" ref={dropdownRef}>
                        <button
                            onClick={() => setCatOpen(!catOpen)}
                            className={`hover:text-[#4048c5] flex items-center gap-1 transition-colors ${catOpen ? 'text-[#4048c5]' : ''}`}
                        >
                            Categories <ChevronDown className={`w-3.5 h-3.5 transition-transform ${catOpen ? 'rotate-180' : ''}`} />
                        </button>
                        {catOpen && (
                            <div className="absolute top-full left-0 mt-2 w-56 bg-white border border-slate-100 rounded-xl shadow-2xl py-2 animate-in fade-in zoom-in-95 duration-200">
                                {CATEGORIES.map((cat) => (
                                    <button
                                        key={cat.id}
                                        onClick={() => {
                                            onSelectCategory(cat.id);
                                            setCatOpen(false);
                                        }}
                                        className="w-full text-left px-4 py-2 text-xs font-bold text-slate-600 hover:bg-slate-50 hover:text-[#4048c5] flex items-center gap-3 transition-all"
                                    >
                                        <span className="text-slate-300">{cat.icon}</span>
                                        {cat.name}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="relative" ref={desktopMenuRef}>
                        <button
                            onClick={() => setMenuOpen(!menuOpen)}
                            className={`hover:text-[#4048c5] flex items-center gap-1 transition-colors ${menuOpen ? 'text-[#4048c5]' : ''}`}
                        >
                            Menu <ChevronDown className={`w-3.5 h-3.5 transition-transform ${menuOpen ? 'rotate-180' : ''}`} />
                        </button>
                        {menuOpen && (
                            <div className="absolute top-full right-0 mt-2 w-64 bg-white border border-slate-100 rounded-xl shadow-2xl py-2 animate-in fade-in zoom-in-95 duration-200">
                                {/* <Link
                                    to="/blog"
                                    onClick={() => setMenuOpen(false)}
                                    className={`w-full text-left px-4 py-3 text-xs font-bold flex items-center gap-3 ${currentView === '/blog' ? 'text-[#4048c5] bg-blue-50/50' : 'text-slate-600 hover:bg-slate-50'}`}
                                >
                                    <BookOpen className="w-4 h-4" /> Blog
                                </Link> */}
                                {/* <Link
                                    to="/docs"
                                    onClick={() => setMenuOpen(false)}
                                    className="w-full text-left px-4 py-3 text-xs font-bold text-slate-600 hover:bg-slate-50 flex items-center gap-3"
                                >
                                    <FileText className="w-4 h-4 text-blue-500" /> Documentation
                                </Link> */}
                                <Link
                                    to="/about"
                                    onClick={() => setMenuOpen(false)}
                                    className="w-full text-left px-4 py-3 text-xs font-bold text-slate-600 hover:bg-slate-50 flex items-center gap-3"
                                >
                                    <Info className="w-4 h-4 text-emerald-500" /> About Us
                                </Link>
                                <Link
                                    to="/contact"
                                    onClick={() => setMenuOpen(false)}
                                    className="w-full text-left px-4 py-3 text-xs font-bold text-slate-600 hover:bg-slate-50 flex items-center gap-3"
                                >
                                    <Mail className="w-4 h-4 text-orange-500" /> Contact Us
                                </Link>
                                <div className="h-px bg-slate-100 my-1 mx-2"></div>
                                <Link
                                    to="/privacy"
                                    onClick={() => setMenuOpen(false)}
                                    className="w-full text-left px-4 py-3 text-xs font-bold text-slate-600 hover:bg-slate-50 flex items-center gap-3"
                                >
                                    <Shield className="w-4 h-4 text-slate-400" /> Privacy Policy
                                </Link>
                                <Link
                                    to="/terms"
                                    onClick={() => setMenuOpen(false)}
                                    className="w-full text-left px-4 py-3 text-xs font-bold text-slate-600 hover:bg-slate-50 flex items-center gap-3"
                                >
                                    <Scale className="w-4 h-4 text-slate-400" /> Terms & Conditions
                                </Link>
                            </div>
                        )}
                    </div>
                </nav>

                <div className="flex items-center gap-3 relative">
                    {/* <button className="p-2 text-slate-600 hover:text-[#4048c5]">
                        <ShoppingBasket className="w-5 h-5" />
                    </button> */}
                    {user ? (
                        <div className="relative" ref={profileMenuRef}>
                            <button
                                onClick={() => setProfileMenuOpen(!profileMenuOpen)}
                                className="w-9 h-9 rounded-full bg-[#4048c5] flex items-center justify-center text-white text-xs font-bold border-2 border-blue-50 shadow-sm cursor-pointer hover:bg-[#3239a0] transition-colors"
                                title={user.name}
                            >
                                {user.name.substring(0, 2).toUpperCase()}
                            </button>
                            {profileMenuOpen && (
                                <div className="absolute right-0 top-full mt-2 w-48 bg-white border border-slate-100 rounded-xl shadow-2xl py-2 animate-in fade-in zoom-in-95 duration-200 z-50">
                                    <button
                                        onClick={handleProfileClick}
                                        className="w-full text-left px-4 py-3 text-xs font-bold text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors"
                                    >
                                        <User className="w-4 h-4 text-slate-500" />
                                        Profile
                                    </button>
                                    <div className="h-px bg-slate-100 my-1"></div>
                                    <button
                                        onClick={handleLogout}
                                        className="w-full text-left px-4 py-3 text-xs font-bold text-red-600 hover:bg-red-50 flex items-center gap-3 transition-colors"
                                    >
                                        <LogOut className="w-4 h-4" />
                                        Logout
                                    </button>
                                </div>
                            )}
                        </div>
                    ) : (
                        <Link
                            to="/login"
                            className="bg-[#4048c5] text-white px-4 py-1.5 rounded-lg text-xs font-bold hover:bg-[#3239a0] transition-colors"
                        >
                            Sign In
                        </Link>
                    )}
                    {/* <button
                        className="lg:hidden p-2 text-slate-600"
                        onClick={() => setMenuOpen(!menuOpen)}
                        ref={mobileMenuRef}
                    >
                        <MenuIcon className="w-5 h-5" />
                    </button> */}
                    {/* Mobile Menu Dropdown */}
                    {menuOpen && (
                        <div className="absolute right-0 top-full mt-2 w-64 bg-white border border-slate-100 rounded-xl shadow-2xl py-2 animate-in fade-in zoom-in-95 duration-200 z-50 xl:hidden">
                            <Link
                                to="/blog"
                                onClick={() => setMenuOpen(false)}
                                className={`w-full text-left px-4 py-3 text-xs font-bold flex items-center gap-3 ${currentView === '/blog' ? 'text-[#4048c5] bg-blue-50/50' : 'text-slate-600 hover:bg-slate-50'}`}
                            >
                                <BookOpen className="w-4 h-4" /> Blog
                            </Link>
                            <Link
                                to="/about"
                                onClick={() => setMenuOpen(false)}
                                className="w-full text-left px-4 py-3 text-xs font-bold text-slate-600 hover:bg-slate-50 flex items-center gap-3"
                            >
                                <Info className="w-4 h-4 text-emerald-500" /> About Us
                            </Link>
                            <Link
                                to="/contact"
                                onClick={() => setMenuOpen(false)}
                                className="w-full text-left px-4 py-3 text-xs font-bold text-slate-600 hover:bg-slate-50 flex items-center gap-3"
                            >
                                <Mail className="w-4 h-4 text-orange-500" /> Contact Us
                            </Link>
                            <div className="h-px bg-slate-100 my-1 mx-2"></div>
                            <Link
                                to="/privacy"
                                onClick={() => setMenuOpen(false)}
                                className="w-full text-left px-4 py-3 text-xs font-bold text-slate-600 hover:bg-slate-50 flex items-center gap-3"
                            >
                                <Shield className="w-4 h-4 text-slate-400" /> Privacy Policy
                            </Link>
                            <Link
                                to="/terms"
                                onClick={() => setMenuOpen(false)}
                                className="w-full text-left px-4 py-3 text-xs font-bold text-slate-600 hover:bg-slate-50 flex items-center gap-3"
                            >
                                <Scale className="w-4 h-4 text-slate-400" /> Terms & Conditions
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;